//actions/languageAction.js
export const languageAction = (language) => {
  return {
    type: "SET_LANGUAGE",
    payload: language,
  };
};
